<template>
    <va-create-layout>
        <CogCatalogItem-form :title="title" :item="item"></CogCatalogItem-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
